<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="请输入题目内容进行搜索，可以直接回车搜索..." prefix-icon="el-icon-search"
                              clearable
							  size="medium"
                              @clear="initEmps"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
					<el-select v-model="questionModel" placeholder="程序模式" clearable style="margin-right: 10px" @change="questionModelChange()">
					    <el-option
					      v-for="item in questionModels"
					      :key="item.kqmId"
					      :label="item.kqmName"
					      :value="item.kqmId">
					    </el-option>
					</el-select>
                    <el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
                    <!-- <el-button type="primary" @click="showAdvanceSearchView = !showAdvanceSearchView">
                        <i :class="showAdvanceSearchView?'fa fa-angle-double-up':'fa fa-angle-double-down'"
                           aria-hidden="true"></i>
                        高级搜索
                    </el-button> -->
                </div>
                <div>
					<!-- <el-button type="success" @click="exportData" icon="el-icon-download">
						导出数据
					</el-button> -->
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加题目
                    </el-button>
                </div>
            </div>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    style="width: 100%">
                <!-- <el-table-column
                        type="selection"
                        width="55">
                </el-table-column> -->
				<el-table-column
				        prop="kqmName"
				        label="所属程序模式"
				        align="center"
				        width="200">
				</el-table-column>
				<el-table-column
				        prop="kqiIndex"
				        align="center"
				        label="题目序号"
				        width="160">
				</el-table-column>
                <el-table-column
                        prop="kqiCode"
                        align="center"
                        label="题目编码"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="kqiName"
                        label="题目内容"
                        align="center"
                        width="280">
                </el-table-column>
                <el-table-column
                        prop="kqiQueType"
                        label="题目类型"
                        align="center"
                        width="80">
						<template slot-scope="scope">
							<span>{{scope.row.kqiQueType == '0' ? '单选题' : '多选题'}}</span>
						</template>
                </el-table-column>
                <el-table-column
                        prop="kqiAddTime"
                        width="160"
                        align="center"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        prop="kqiAddUserName"
                        width="100"
                        align="center"
                        label="创建人">
                </el-table-column>
                <el-table-column
                        prop="kqiUpdateTime"
                        width="160"
						align="center"
                        label="最新修改时间">
                </el-table-column>
                <el-table-column
                        prop="kqiUpdateUserName"
                        width="100"
						align="center"
                        label="最新修改人">
                </el-table-column>
                <el-table-column
						align="center"
                        prop="kqiIsEnableStr"
                        width="80"
                        label="题目状态">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        width="140"
						align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
						:current-page.sync="page"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
				v-loading="loading2"
				element-loading-text="正在加载..."
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)"
                width="80%">
            <div class="dialog-box">
                <el-form :model="question" :rules="rules" ref="empForm">
					<el-row>
						<el-col :span="8">
							<el-form-item label="程序模式" prop="kqiQueModelid">
								<el-select v-model="question.kqiQueModelid" placeholder="程序模式" clearable style="margin-right: 10px">
									<el-option
									  v-for="item in questionModels"
									  :key="item.kqmId"
									  :label="item.kqmName"
									  :value="item.kqmId">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="复制的题目:" >
								<div style="display: flex;">
									<el-select v-model="copyFromQmId"  placeholder="选择程序模式" clearable style="margin-right: 10px" @change="selectQmChange">
										<el-option
										  v-for="item in totalQuestionModels"
										  :key="item.kqmId"
										  :label="item.kqmName"
										  :value="item.kqmId">
										</el-option>	
									</el-select>
									<el-select v-model="copyFromQuId" placeholder="选择题目编码" clearable style="margin-right: 10px" @change="selectQuChange">
										<el-option
										  v-for="item in tempQustions"
										  :key="item.kqiId"
										  :label="item.kqiCode + ' ' + item.kqiName"
										  :value="item.kqiId">
										</el-option>	
									</el-select>
								</div>
						
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-form-item label="题目序号" prop="kqiIndex">
							<div class="input_box">
								<el-input prefix-icon="el-icon-edit" v-model="question.kqiIndex"
								          placeholder="请输入题目序号" maxlength="3" show-word-limit></el-input>
							</div>
						</el-form-item>
					</el-row>
					<el-row>
						<el-form-item label="题目编码" prop="kqiCode">
							<div class="input_box">
								<el-input prefix-icon="el-icon-edit" v-model="question.kqiCode"
								          placeholder="请输入题目编码" maxlength="20" show-word-limit></el-input>
							</div>
						</el-form-item>
					</el-row>
					<el-row>
						<el-form-item label="题目内容" prop="kqiName">
							<div class="input_box">
								<el-input type="textarea" prefix-icon="el-icon-edit" v-model="question.kqiName"
								          placeholder="请输入题目内容" maxlength="200" show-word-limit></el-input>
							</div>
						</el-form-item>
					</el-row>
					<el-row>
						<el-form-item label="帮助说明" prop="kqiName">
							<div class="input_box">
								<el-input type="textarea" prefix-icon="el-icon-edit" v-model="question.kqiIllustrate"
								          placeholder="请输入题目帮助说明" maxlength="200" show-word-limit></el-input>
							</div>
						</el-form-item>
					</el-row>
					<!-- <el-row>
						<el-form-item label="帮助说明:" prop="kqiIllustrate">
							<div class="input_box">
								<el-input type="textarea" prefix-icon="el-icon-edit" v-model="question.kqiIllustrate"
								          placeholder="请输入帮助说明" maxlength="200" show-word-limit></el-input>
							</div>
						</el-form-item>
					</el-row> -->
					<el-row>
						<el-col :span="12">
						    <el-form-item label="题目类型:" prop="kqiQueType">
						        <el-radio-group v-model="question.kqiQueType">
						            <el-radio :label="0">单选题</el-radio>
						            <el-radio :label="1">多选题</el-radio>
						        </el-radio-group>
						    </el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
						    <el-form-item label="题目状态:" prop="kqiIsEnable">
						        <el-radio-group v-model="question.kqiIsEnable">
						            <el-radio :label="0">启用</el-radio>
						            <el-radio :label="1">停用</el-radio>
						        </el-radio-group>
						    </el-form-item>
						</el-col>
					</el-row>
					<div class="que_tit">题目选项:</div>
					<template v-for="(item,index) in question.kytOptions">
						<div class="body_warp">
							<el-button type="primary" size="mini" style="margin: 0;" v-show="index == 0" icon="el-icon-plus" circle @click="addOption(item)"></el-button>
							<el-button type="primary" size="mini" style="margin: 0;" v-show="index > 0" icon="el-icon-minus" circle @click="minusOption(item)"></el-button>
							<div class="flex-start-warp" style="margin-left: 0.625rem;">
								<el-form-item label="" :prop="`kytOptions.${index}.koiOption`" :rules="rules.koiOption">
									<div class="options_warp conts">
										<div class="input_box flex-center option_item">
											<el-input size="mini" prefix-icon="el-icon-edit" v-model="item.koiOption"
													  placeholder="请输入选项内容" maxlength="100" show-word-limit></el-input>								</div>
									</div>
								</el-form-item>
								<el-form-item label="" :prop="`kytOptions.${index}.koiOpIllustrate`" :rules="rules.koiOpIllustrate">
									<div class="options_warp opremark">
										<div class="input_box flex-center option_item">
											<el-input size="mini" prefix-icon="el-icon-edit" v-model="item.koiOpIllustrate"
													  placeholder="请输入选项帮助说明" maxlength="100" show-word-limit></el-input>								</div>
									</div>
								</el-form-item>
								<el-form-item label="" :prop="`kytOptions.${index}.koiOptionCode`" :rules="rules.koiOptionCode">
									<div class="options_warp opcode">
										<div class="input_box flex-center option_item">
											<el-input size="mini" prefix-icon="el-icon-edit" v-model="item.koiOptionCode"
													  placeholder="请输入选项代码" maxlength="10" show-word-limit></el-input>									
										</div>
									</div>
								</el-form-item>
								<!-- <el-form-item label="" :prop="`kytOptions.${index}.koiOptionVal`" :rules="rules.koiOptionVal">
									<div class="options_warp opval">
										<div class="input_box flex-center option_item">
											<el-input size="mini" prefix-icon="el-icon-edit" v-model="item.koiOptionVal"
													  placeholder="请输入值(An)" maxlength="10" show-word-limit></el-input>									
										</div>
									</div>
								</el-form-item> -->
								<el-form-item label="" v-show="question.kqiQueType == '1'">
									<div class="options_warp oprepel">
										<div class="input_box flex-center option_item">
											<el-select v-model="item.koiOptionMutualExclusion" size="mini" collapse-tags multiple placeholder="请选择互斥项" >
											    <el-option
											      v-for="item in question.kytOptions"
											      :key="item.koiId"
											      :label="item.koiOption"
											      :value="item.koiOptionCode">
											    </el-option>
											  </el-select>								
										</div>
									</div>
								</el-form-item>
								<el-form-item label="子选项" :prop="`kytOptions.${index}.koiHasChild`" :rules="rules.koiHasChild">
									<el-radio-group v-model="item.koiHasChild" @change="(val)=>{changeHasOpChild(val,item)}">
									    <el-radio :label="1">有</el-radio>
									    <el-radio :label="0">无</el-radio>
									  </el-radio-group>
								</el-form-item>
							</div>
						</div>
						<template v-if="item.koiHasChild == '1'">	
							<div class="child_body_warp" v-for="(childOption,index) in item.koiChildsOption">
								<el-button type="primary" size="mini" style="margin: 0;" v-show="index == 0" icon="el-icon-plus" circle @click="addChildOption(item)"></el-button>
								<el-button type="primary" size="mini" style="margin: 0;" v-show="index > 0" icon="el-icon-minus" circle @click="minusChildOption(item,childOption)"></el-button>
								<div class="flex-start-warp" style="margin-left: 0.625rem;">
									<!-- <el-form-item label="" :prop="`koiChildsOption.${index}.koiOption`" :rules="rules.koiOption"> -->
									<el-form-item label="">
										<div class="options_warp conts">
											<div class="input_box flex-center option_item">
												<el-input size="mini" prefix-icon="el-icon-edit" v-model="childOption.koiOption"
														  placeholder="请输入选项内容" maxlength="100" show-word-limit></el-input>								</div>
										</div>
									</el-form-item>
									<!-- <el-form-item label="" :prop="`koiChildsOption.${index}.koiOpIllustrate`" :rules="rules.koiOpIllustrate"> -->
									<el-form-item label="" >
										<div class="options_warp opremark">
											<div class="input_box flex-center option_item">
												<el-input size="mini" prefix-icon="el-icon-edit" v-model="childOption.koiOpIllustrate"
														  placeholder="请输入选项帮助说明" maxlength="100" show-word-limit></el-input>								</div>
										</div>
									</el-form-item>
									<!-- <el-form-item label="" :prop="`koiChildsOption.${index}.koiOptionCode`" :rules="rules.koiOptionCode"> -->
									<el-form-item label="" >
										<div class="options_warp opcode">
											<div class="input_box flex-center option_item">
												<el-input size="mini" prefix-icon="el-icon-edit" v-model="childOption.koiOptionCode"
														  placeholder="请输入选项代码" maxlength="10" show-word-limit></el-input>									
											</div>
										</div>
									</el-form-item>
									<!-- <el-form-item label="" :prop="`koiChildsOption.${index}.koiOptionVal`" :rules="rules.koiOptionVal"> -->
									<!-- <el-form-item label="">
										<div class="options_warp opval">
											<div class="input_box flex-center option_item">
												<el-input size="mini" prefix-icon="el-icon-edit" v-model="childOption.koiOptionVal"
														  placeholder="请输入值(An)" maxlength="10" show-word-limit></el-input>									
											</div>
										</div>
									</el-form-item> -->
									
								</div>
							</div>
						</template>
					</template>
                    <el-row>
						
                    </el-row>

                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="doAddEmp">确 定</el-button>
			  </span>
        </el-dialog>
    </div>
</template>

<script>
	import { Loading } from 'element-ui';
	import { v4 as uuidv4 } from 'uuid'
    export default {
        name: "Tenants",
        data() {
            return {
				copyFromQmId:'',
				copyFromQuId:'',
                title: '',
				showAdvanceSearchView: false,
                allDeps: [],
                emps: [],
                loading: false,
				loading2: false,
                dialogVisible: false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
				optionIndex:[
					'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'
				],
                question: {
					kqiCode:'',
					kqiName:'',
					kqiIndex:'',
					kqiFormulaId:'',
					kqiIllustrate:'',
					kqiIsEnable:'',
					kytOptions:[
						{
							koiId:'',
							koiIndex:'',
							koiOption:'',
							koiOpIllustrate:'',
							koiOptionCode:'',
							koiOptionVal:'',
							koiOptionMutualExclusion:[],
							koiHasChild:'0',
							koiChildsOption:[
								
							]
						}
					],
					kqiQueType:'',
					kqiQueModelid:''
                },
                rules: {
					kqiQueModelid: [{required: true, message: '请选择程序模式', trigger: 'blur'}],
					kqiIndex: [{required: true, message: '请输入题目序号', trigger: 'blur'}],
                    kqiName: [{required: true, message: '请输入题目内容', trigger: 'blur'}],
					koiOption:[{required: true, message: '请输入选项内容', trigger: 'blur'}],
					kqiIsEnable: [{required: true, message: '请选择题目状态', trigger: 'blur'}],
					kqiQueType: [{required: true, message: '请选择题目类型', trigger: 'blur'}],
					koiOpIllustrate:[{required: true, message: '请输入选项帮助说明', trigger: 'blur'}],
					koiOptionCode:[{required: true, message: '请输入问题选项代码', trigger: 'blur'}],
					/* koiOptionVal:[{required: true, message: '请输入值', trigger: 'blur'}], */
					koiHasChild:[{required: true, message: '是否有子选项', trigger: 'blur'}]
                },
				formulasEnableList:[],
				questionModels:[],
				questionModel:'',
				totalQuestionModels:[],
				tempQustions:[]
            }
        },
        mounted() {
            this.initEmps();
            this.initData();
			this.totalModels();
        },
        methods: {
			selectQmChange(e){
				console.log(e)
				this.copyFromQuId = ''
				this.tempQustions = []
				this.getQuestionsByQmId(e)
			},
			selectQuChange(e){
				console.log(e)
				this.queryQuestionInfoForCopy({kqiId : e})
			},
			questionModelChange(){
				this.page = 1
				this.initEmps();
			},
			changeHasOpChild(e,item){
				if(e == 1){
					console.log(item)
					const uuid = uuidv4()
					var opIndex = this.$util.getCurrentTime();
					if(item.koiChildsOption.length > 0){
						
					}else{
						item.koiChildsOption.push(
							{
								koiId:uuid,
								koiIndex:opIndex,
								koiOption:'',
								koiOpIllustrate:'',
								koiOptionCode:'',
								koiOptionVal:'',
								koiOptionMutualExclusion:[]
							}
						);
					}
					
				}else{
					
				}
			},
			ExcluChange(curroption,excluCodes){
				console.log(curroption)
				console.log(excluCodes)
				curroption.koiOptionMutualExclusion = excluCodes
				var kytOptions = this.question.kytOptions;
				this.question.kytOptions.forEach(function(option){
					excluCodes.forEach(function(code){
						if(option.koiOptionCode == code){
							if(!option.koiOptionMutualExclusion.includes(code)){
								option.koiOptionMutualExclusion.push(curroption.koiOptionCode)
							}
						}
					})
				})
			},
			trendsOption(index){
				//return '题目选项'+this.optionIndex[index]+":"
				return '题目选项:';
			},
			trendsAnOption(index){
				return 'a'+(index + 1)
			},
			minusChildOption(item,childOption){
				var curoptions = item.koiChildsOption.filter(e => {
					return e.koiId != childOption.koiId 
				})
				console.log(curoptions)
				item.koiChildsOption = curoptions
			},
			addChildOption(item){
				const uuid = uuidv4()
				var opIndex = this.$util.getCurrentTime();
				console.log(opIndex)
				item.koiChildsOption.push(
					{
						koiId:uuid,
						koiIndex:opIndex,
						koiOption:'',
						koiOpIllustrate:'',
						koiOptionCode:'',
						koiOptionVal:'',
						koiOptionMutualExclusion:[]
					}
				)
			},
			addOption(){
				const uuid = uuidv4()
				var opIndex = this.$util.getCurrentTime();
				console.log(opIndex)
				this.question.kytOptions.push(
					{
						koiId:uuid,
						koiIndex:opIndex,
						koiOption:'',
						koiOpIllustrate:'',
						koiOptionCode:'',
						koiOptionVal:'',
						koiOptionMutualExclusion:[],
						koiHasChild:'0',
						koiChildsOption:[
							
						]
					}
				)
			},
			minusOption(item){
				var curoptions = this.question.kytOptions.filter(e => {
					return e.koiId != item.koiId 
				})
				console.log(curoptions)
				this.question.kytOptions = curoptions
			},
            exportData() {
                window.open('/apis/tenant/basic/export', '_parent');
            },
            emptyEmp() {
				const uuid = uuidv4()
				var opIndex = this.$util.getCurrentTime();
				console.log(opIndex)
                this.question = {
					kqiCode:'',
					kqiIndex:'',
					kqiName:'',
					kqiFormulaId:'',
					kqiIllustrate:'',
					kqiIsEnable:'',
					kytOptions:[
						{
							koiId:uuid,
							koiIndex:opIndex,
							koiOption:'',
							koiOpIllustrate:'',
							koiOptionCode:'',
							koiOptionVal:'',
							koiOptionMutualExclusion:[],
							koiHasChild:'0',
							koiChildsOption:[
								
							]
						}
					],
					kqiQueType:'',
					kqiQueModelid:''
                }
				this.question.kytOptions = [{
					koiId:uuid,
					koiIndex:opIndex,
					koiOption:'',
					koiOpIllustrate:'',
					koiOptionCode:'',
					koiOptionVal:'',
					koiOptionMutualExclusion:[],
					koiHasChild:'0',
					koiChildsOption:[
						
					]
				}]
				this.copyFromQmId = ''
				this.copyFromQuId = ''
            },
            showEditEmpView(data) {
                this.title = '编辑题目信息';
                this.emp = data;
                this.dialogVisible = true;
				this.queryQuestionInfo(data);
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/question/basic/del/" + data.kqiId).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
			getQuestionsByQmId(QmId){
				this.loading2 = true;
				let url = '/question/basic/getQuestionsByQmId/'+QmId;
				this.getRequest(url).then(resp => {
				    this.loading2 = false;
				    if (resp.status == 200) {
						this.tempQustions = resp.obj
				    }else{
						this.$message({
						    type: 'info',
						    message: '查询信息有误'
						});
					}
				});
			},
			queryQuestionInfoForCopy(data){
				this.loading2 = true;
				let url = '/question/basic/getQuestionInfoById/'+data.kqiId;
				this.getRequest(url).then(resp => {
			        this.loading2 = false;
			        if (resp.status == 200) {
						this.question.kqiCode = resp.obj.kqiCode;
						this.question.kqiName = resp.obj.kqiName;
						this.question.kqiIllustrate = resp.obj.kqiIllustrate;
						this.question.kqiIsEnable = parseInt(resp.obj.kqiIsEnable)
						this.question.kqiQueType = parseInt(resp.obj.kqiQueType)
						this.question.kytOptions = resp.obj.kytOptions;
						/* this.question.kqiIndex = resp.obj.kqiIndex; */
						
			        }else{
						this.$message({
						    type: 'info',
						    message: '查询信息有误'
						});
					}
			    });
			},
			queryQuestionInfo(data){
				this.loading2 = true;
				let url = '/question/basic/getQuestionInfoById/'+data.kqiId;
				this.getRequest(url).then(resp => {
                    this.loading2 = false;
                    if (resp.status == 200) {
						this.question.kqiCode = resp.obj.kqiCode;
						this.question.kqiName = resp.obj.kqiName;
						this.question.kqiIllustrate = resp.obj.kqiIllustrate;
						this.question.kqiId = resp.obj.kqiId;
						this.question.kqiIsEnable = parseInt(resp.obj.kqiIsEnable)
						this.question.kqiQueType = parseInt(resp.obj.kqiQueType)
						this.question.kytOptions = resp.obj.kytOptions;
						this.question.kqiIndex = resp.obj.kqiIndex;
						this.question.kqiQueModelid = resp.obj.kqiQueModelid;
						
                    }else{
						this.$message({
						    type: 'info',
						    message: '查询信息有误'
						});
					}
                });
			},
            doAddEmp() {
				//let loadingInstance = Loading.service({ fullscreen: true });
				console.log(this.question)
                if (this.question.kqiId) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/question/basic/update", this.question).then(resp => {
								this.$nextTick(() => {
								  loadingInstance.close();
								});
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }else{
							this.$nextTick(() => {
							  loadingInstance.close();
							});
						}
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/question/basic/add", this.question).then(resp => {
								this.$nextTick(() => {
								  loadingInstance.close();
								});
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }else{
							this.$nextTick(() => {
							  loadingInstance.close();
							});
						}
                    });
                } 
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            initData() {
				this.getFormulasEnableList()
				this.getQuestionModelsList()
            },
			getFormulasEnableList(){
				let url = '/formula/basic/getFormulasEnableList';
				this.getRequest(url).then(resp => {
			        if (resp.status == 200) {
						this.formulasEnableList = resp.obj;
			        }else{

					}
			    });
			},
			getQuestionModelsList(){
				this.questionModels = []
				let url = '/question/basic/getQuestionModelsList';
				this.getRequest(url).then(resp => {
			        if (resp.status == 200) {
						this.questionModels = resp.obj;
			        }else{
			
					}
			    });
			},
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加题目';
                this.dialogVisible = true;
            },
            initEmps(type) {
                this.loading = true;
                let url = '/question/basic/getQuestionsList?page=' + this.page + '&size=' + this.size;
                url += "&kqiName=" + this.keyword;
				url += "&questionModel=" + this.questionModel;
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });
            },
			totalModels(){
				let url = '/question/basic/getQuestionModelsList';
				this.getRequest(url).then(resp => {
				    if (resp) {
				        this.totalQuestionModels = resp.obj;
				    }
				});
			}
        }
    }
</script>

<style scoped lang="scss">
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
	.que_tit {
		margin-bottom: 0.625rem;
	}
	.flex-start-warp {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
		justify-content: flex-start;
	}
	.body_warp {
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
	}
	.child_body_warp {
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		padding-left: 2.1875rem;
	}
	.el-form-item {
		display: flex;
		.input_box {
			width: 28.5rem;
			.el-input {
				width: 100% !important;
			}
			.el-select {
				width: 100% !important;
				margin-left: 0 !important;
				margin-right: 0 !important;
			}
		}
	}
	.advance_seit_box {
		line-height: 2.5rem;
		height: 2.5rem;
		font-size: 0.875rem;
		.box_tit {
			font-size: 0.875rem;
		}
	}
	.advance_btn_warp {
		line-height: 2.5rem;
		height: 2.5rem;
	}
	.options_warp {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		.option_item {
			
		}
		
	}
	.conts {
		margin-right: 0.25rem;
		.input_box {
			width: 16rem;
		}
	}
	.opremark {
		margin-right: 0.25rem;
		.input_box {
			width: 16rem;
		}
	}
	.opcode {
		margin-right: 0.25rem;
		.input_box {
			width: 12rem;
		}
	}
	.opval {
		margin-right: 0.25rem;
		.input_box {
			width: 12rem;
		}
	}
	.oprepel {
		margin-right: 0.25rem;
		.input_box {
			width: 14rem;
		}
	}
	::v-deep .dialog-box {
		.el-form-item__label {
			width: 7.125rem;
		}
	}

</style>
